export default from './Error';



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoUploader/components/Error/index.js